import merge from 'deepmerge'

import MechanismParser from './mechanism'
import parsePlaybook from './playbook'

import { ParsingError } from './parsing-utils'

import Rulebook from '../models'

const PARSER_VERSION = 1.0

export default function parse (rulebooks, log=console.log) {
  validate(rulebooks)
  const rawRules = merge.all(rulebooks)
  const mechanismParser = new MechanismParser(rawRules)
  const rulebookNames = rulebooks.map(({ game, rulebook }) => `${game} ${rulebook}`)
  const rulebook = new Rulebook(rulebookNames, Object.entries(rawRules.mechanisms).map(([name, raw]) => mechanismParser.parse(name, raw)))
  rulebook.playbooks = Object.entries(rawRules.playbooks).map(([name, raw]) => parsePlaybook(name, raw, rulebook, mechanismParser))
  return rulebook
}

function validate (rulebooks) {
  if (rulebooks.some(rulebook => rulebook.parser < PARSER_VERSION))
    throw new ParsingError(`An outdated rulebook found. All rulebooks must be at least of version ${PARSER_VERSION}`)

  const coreRulebooksCount = rulebooks.filter(rulebook => rulebook.rulebook === 'core').length
  if (coreRulebooksCount === 0) throw new ParsingError('No core rulebook found. A game must contain a core rulebook.')
  if (coreRulebooksCount > 1)   throw new ParsingError('Multiple core rulebooks found. Only one core rulebook is allowed.')
}

/*
# TODO fix number calculations using formulas and fields

YAML (and helping it in other places)
# TODO add max and min to fields
# TODO trigger moves by their names
# TODO modifiers
# TODO fields changing: set vs change vs reduce/add
# TODO constant sentencing: where do we use capital letters? Points? Question marks?
# TODO hirelings mechanism
# TODO first moves moves (override "moves" mechanism in ranger)
# TODO remove enumeration types
# TODO what about moves that describe the choices in the start of the game? Create "instant" trigger, can a move have a character-choice and another trigger? It should.
# TODO Finish all moves for playbooks
# TODO multi-class moves

FINALIZE
# UT, coverage and lint
# CI/CD to NPM
*/
